// extracted by mini-css-extract-plugin
export var button_copy = "color-module--button_copy--e91d7";
export var button_option = "color-module--button_option--e6b5f";
export var color_code = "color-module--color_code--17bac";
export var color_locked = "color-module--color_locked--98fef";
export var color_wrapper = "color-module--color_wrapper--5af53";
export var container_options = "color-module--container_options--15faa";
export var lock_button = "color-module--lock_button--73665";